export default "__VITE_ASSET__DkBkrHB3__"